import {
    INIT_ORDER_INFO,

    CHECKOUT_FAIL,
    CHECKOUT_START,
    CHECKOUT_SUCCESS,

    REQUEST_PAYMENT_TYPE_FAIL,
    REQUEST_PAYMENT_TYPE_START,
    REQUEST_PAYMENT_TYPE_SUCCESS,

    GET_CART_LIST_START,
    GET_CART_LIST_SUCCESS,
    GET_CART_LIST_FAIL,

    EDIT_CART_START,
    EDIT_CART_SUCCESS,
    EDIT_CART_FAIL,

    CREATE_ORDER_FAIL,
    CREATE_ORDER_START,
    CREATE_ORDER_SUCCESS,

    REQUEST_ORDER_FAIL,
    REQUEST_ORDER_START,
    REQUEST_ORDER_SUCCESS,

    REQUEST_DELIVERY_TYPE_FAIL,
    REQUEST_DELIVERY_TYPE_START,
    REQUEST_DELIVERY_TYPE_SUCCESS,

    REQUEST_ORDER_STATE_FAIL,
    REQUEST_ORDER_STATE_START,
    REQUEST_ORDER_STATE_SUCCESS,

    REQUEST_ORDER_HISTORY_LIST_FAIL,
    REQUEST_ORDER_HISTORY_LIST_START,
    REQUEST_ORDER_HISTORY_LIST_SUCCESS,

    ORDER_HISTORY_SET_STATE_FAIL,
    ORDER_HISTORY_SET_STATE_START,
    ORDER_HISTORY_SET_STATE_SUCCESS,

    REQUEST_ORDER_HISTORY_DETAIL_FAIL,
    REQUEST_ORDER_HISTORY_DETAIL_START,
    REQUEST_ORDER_HISTORY_DETAIL_SUCCESS,

    REQUEST_GEO_FAIL,
    REQUEST_GEO_START,
    REQUEST_GEO_SUCCESS,

    ORDER_HISTORY_CALCULATE_FAIL,
    ORDER_HISTORY_CALCULATE_START,
    ORDER_HISTORY_CALCULATE_SUCCESS,

    ORDER_HISTORY_EDIT_FAIL,
    ORDER_HISTORY_EDIT_START,
    ORDER_HISTORY_EDIT_SUCCESS,

    EXPORT_ORDER_HISTORY_FAIL,
    EXPORT_ORDER_HISTORY_START,
    EXPORT_ORDER_HISTORY_SUCCESS,

    REQUEST_ORDER_CALCULATE_LIST_START,
    REQUEST_ORDER_CALCULATE_LIST_SUCCESS,
    REQUEST_ORDER_CALCULATE_LIST_FAIL

} from '../actions/order';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {
    const { type, data, payload, error } = action;
    switch (type) {

        case CHECKOUT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case CHECKOUT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case CHECKOUT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================


        case REQUEST_PAYMENT_TYPE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_PAYMENT_TYPE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_PAYMENT_TYPE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case GET_CART_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case GET_CART_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case GET_CART_LIST_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case EDIT_CART_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case EDIT_CART_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case EDIT_CART_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case CREATE_ORDER_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case CREATE_ORDER_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case CREATE_ORDER_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case REQUEST_ORDER_HISTORY_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_ORDER_HISTORY_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_ORDER_HISTORY_LIST_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case REQUEST_ORDER_STATE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_ORDER_STATE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_ORDER_STATE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case REQUEST_ORDER_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_ORDER_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_ORDER_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case REQUEST_DELIVERY_TYPE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_DELIVERY_TYPE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_DELIVERY_TYPE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================


        case ORDER_HISTORY_SET_STATE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case ORDER_HISTORY_SET_STATE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case ORDER_HISTORY_SET_STATE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case REQUEST_ORDER_HISTORY_DETAIL_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_ORDER_HISTORY_DETAIL_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_ORDER_HISTORY_DETAIL_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case REQUEST_GEO_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_GEO_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_GEO_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case ORDER_HISTORY_CALCULATE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case ORDER_HISTORY_CALCULATE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case ORDER_HISTORY_CALCULATE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case ORDER_HISTORY_EDIT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case ORDER_HISTORY_EDIT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.response, ...payload.res, isLoading: false, type } }
            }

        case ORDER_HISTORY_EDIT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        case EXPORT_ORDER_HISTORY_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case EXPORT_ORDER_HISTORY_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case EXPORT_ORDER_HISTORY_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================

        //=======================================================================================

        case REQUEST_ORDER_CALCULATE_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_ORDER_CALCULATE_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_ORDER_CALCULATE_LIST_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //=======================================================================================


        case INIT_ORDER_INFO:
            {
                return initialState;
            }

        default:
            {
                return { ...state };
            }
    }
};

export default reducer;
